import { createFileRoute } from '@tanstack/react-router';
import { MaintenanceConsole } from '@/features/admin/MaintenanceConsole';

/**
 * Manutenzione sistema (super-admin): i 7 endpoint idempotenti di seed/backfill del BE
 * con l'esito in chiaro — seed claim dei profili, backfill ruoli dipendenti e responsabili,
 * seed tipi di assenza e moduli HR, ricalcolo del maturato ferie.
 */
export const Route = createFileRoute('/_app/admin/maintenance')({ component: MaintenanceConsole });
